export const MESSAGE_DETAIL = 'MESSAGE_DETAIL';

